
import { mapActions } from 'vuex'
const Cookie = process.client ? require('js-cookie') : undefined

export default {
  name: 'ModalPopUpComponent',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalShow: false,
      isAccounts: false,
      isCompanies: false,
      count: 15,
    }
  },
  created() {
    if (process.client) {
      this.$nuxt.$on('onModalselectAccount', (data) => {
        if (Cookie.get(`access_user_${process.env.NODE_ENV}`)) {
          console.log('modalShow', data)
          this.isAccounts = data?.accounts // false
          this.isCompanies = data?.companies
          this.modalShow = true

          if (!this.isAccounts && this.isCompanies) {
            const interval = setInterval(() => {
              if (this.count > 0) {
                this.count--
              } else {
                clearInterval(interval)
                // this.onClose()
                // this.signout()
                // this.removeUserProfile()
                // window.location.reload()
                // window.location = `${process.env.NUXT_ENV_BIZ_DOMAIN}/select-account`
                // window.open(
                //   `${process.env.NUXT_ENV_BIZ_DOMAIN}/select-account`,
                //   '_blank'
                // )
                this.onRouteEpro()
              }
            }, 1000)
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (process.client) {
      this.$nuxt.$off('onModalselectAccount')
    }
  },
  mounted() {},
  methods: {
    ...mapActions('authen', ['signout']),
    ...mapActions('user', ['removeUserProfile']),
    onRouteEpro() {
      this.modalShow = false
      this.signout()
      this.removeUserProfile()
      // this.$router.push({ path: this.$i18n.path('login') })
      // window.location.reload()
      // window.open(`${process.env.NUXT_ENV_BIZ_DOMAIN}/select-account`, '_blank')
      window.location =
        this.$i18n.locale === 'th'
          ? `${process.env.NUXT_ENV_BIZ_DOMAIN}/select-account`
          : `${process.env.NUXT_ENV_BIZ_DOMAIN}/${this.$i18n.locale}/select-account`
    },
    onRouteStandard() {
      this.$router.push({
        path: this.$i18n.path('select-account'),
      })
    },
    onClose() {
      this.modalShow = false
    },
  },
}
